class Dropdown {
    create({
        target,
        options,
        onSelect,
        defaultText,
    }) {
        this.target = target;
        this.target.innerHTML = `
            <select class="vj__select">
                <option value="default">- ${defaultText} -</option>
                ${this.optionsToHTML(options)}
            </select>
        `;
        this.dropdown = this.target.querySelector('select');
        this.dropdown.addEventListener('change', (e) => {
            const selected = e.target.value;
            if (selected !== 'default') {
                onSelect(parseInt(e.target.value, 10));
            }
        });
    }

    optionsToHTML(optionsList) {
        const createOption = option => `<option value=${option.id}>${option.value}</option>`;
        return optionsList.reduce((html, option) => (
            `${html}
            ${createOption(option)}`
        ), '');
    }

    reset() {
        this.dropdown.selectedIndex = 0;
    }
}

export default new Dropdown();
